<template>
    <div>
        <b-btn class="btn btn-sm btn-secondary new-hazard" title="Add New Hazard" v-if="showButton" v-on:click="openHazardModel=true">
            <i class="fa fa-plus-circle"></i>
        </b-btn>

        <!-- Modal Component -->
        <b-modal v-model="openHazardModel" title="New Hazard" size="lg" ok-title="Create Hazard" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="hazardModal" :no-close-on-backdrop="true" scrollable>

            <div v-bind:class="{ 'form-group': true, 'has-error': errors.hazard_name }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.hazard_name}">
                    Hazard Name: <i class="fa fa-asterisk text-danger"></i>
                </label>
                <div class="col-sm-8">
                    <input type="text" name="hazard_name" v-model="hazard.hazard_name" :class="{'form-control': true, 'is-invalid': errors.hazard_name}" placeholder="Enter Hazard Name" />
                    <span v-if="errors.hazard_name" class="text-danger">
                        <span v-for="error in errors.hazard_name">{{ error }}</span>
                    </span>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {

        props: {
            showButton: {
                type: Boolean,
                default: true,
            },
        },

        data: function() {
            return {
                loading: true,
                hazard: {},
                openHazardModel: false,
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            show(){
                this.openHazardModel = true;
            },

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.hazard = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveHazard();
            },

            saveHazard() {
                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/hazard', this.hazard)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Hazard Saved');

                    //Close the modal
                    this.$refs.hazardModal.hide();

                    //Return to main list?
                    this.$emit('hazardCreated', response.data);

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    this.$emit('hazardFailed', null);
                })
            },
        },

        mounted() {
            //SEt the height
            //console.log(this.$refs.hazardModal.$refs);
            //this.$refs.hazardModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>

<style scoped>
    .new-hazard {
        position: absolute;
        top: 0;
        right: -28px;
        height: 38px;
    }
</style>